import { getFaq } from "./faq";
import { getPrivacyPolicy, getTermsAndConditions } from "./documents";
import { getPromotionBanner } from "./promotion";

const defaultExport = {
  getFaq,
  getPrivacyPolicy,
  getTermsAndConditions,
  getPromotionBanner,
};
export default defaultExport;
